<div class="msg">{{ data.message | translate: data.messageParameters }}</div>
<button mat-icon-button id="snackbarCloseButton" (click)="snackbarRef.dismiss()">
  <mat-icon>close</mat-icon>
</button>
